import { useState } from 'react'
import { Box, Button, CircularProgress, Tooltip } from '@mui/material'
import { DocumentFile, StatementFormat } from '../api/types'
import { saveDocumentFile } from '../api/download'
import { apiError } from '../api/errors'

interface StatementButtonsProps {
  /** Načte vyúčtování v daném formátu z BE. */
  load: (format: StatementFormat) => Promise<DocumentFile>
  /** Popisek pro tooltip (komu vyúčtování patří). */
  title?: string
  onError?: (message: string) => void
}

/** Dvojice tlačítek PDF / Excel pro stažení vyúčtování fee. */
export function StatementButtons({ load, title, onError }: StatementButtonsProps) {
  const [busy, setBusy] = useState<StatementFormat | null>(null)

  const download = (format: StatementFormat) => {
    setBusy(format)
    load(format)
      .then(saveDocumentFile)
      .catch((err) => onError?.(apiError(err, 'Vyúčtování se nepodařilo stáhnout')))
      .finally(() => setBusy(null))
  }

  const button = (format: StatementFormat, label: string) => (
    <Tooltip title={(title ? title + ' – ' : '') + (format === 'pdf' ? 'PDF' : 'Excel se vzorci')}>
      <span>
        <Button
          size="small"
          variant="text"
          onClick={() => download(format)}
          disabled={busy !== null}
          sx={{ minWidth: 0, px: 1 }}
        >
          {busy === format ? <CircularProgress size={14} /> : label}
        </Button>
      </span>
    </Tooltip>
  )

  return (
    <Box sx={{ display: 'inline-flex', gap: 0.5 }}>
      {button('pdf', 'PDF')}
      {button('xlsx', 'Excel')}
    </Box>
  )
}
